/**
 * Feedback API Service
 *
 * HTTP client for feedback API endpoints
 */

import { api } from '@xtnd/web/shared/api';
import type { CreateFeedbackRequest, FeedbackResponse } from '../types';

class FeedbackApiService {
  private readonly baseResource = '/support/feedback';

  /**
   * Submit feedback
   */
  async submitFeedback(data: CreateFeedbackRequest): Promise<FeedbackResponse> {
    return await api.post<FeedbackResponse>(this.baseResource, data);
  }
}

// Export singleton instance
export const feedbackApi = new FeedbackApiService();

